/**
 * HintBadge — selo das mensagens comparativas dos campos de pagamento
 * ("Pagamento antecipado", "Desconto: R$ …"). Nada renderiza quando não há dica.
 */
import { Hint, hintClass } from './paymentHints';

const HintBadge: React.FC<{ hint: Hint | null }> = ({ hint }) =>
    hint ? <div className="mt-1"><span className={hintClass(hint.tone)}>{hint.text}</span></div> : null;

export default HintBadge;
